<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="7">
          <el-form-item
            :label="$l('form_label_materialNo') || '物料编号'"
            prop="materialNo"
          >
            <el-input
              v-model="formData.materialNo"
              readonly
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (chooseMaterialDialogVisible = true)"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$l('form_label_materialName') || '物料名称'">
            <el-input v-model="formData.materialName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="'物料分类'">
            <el-input v-model="formData.detailMaterialCategoryName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$l('form_label_ncNo') || 'NC编号'">
            <el-input
              v-model.trim="formData.ncNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$l('form_label_materialSpec') || '物料规格'">
            <el-input
              v-model.trim="formData.materialSpec"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$l('form_label_materialUnit') || '物料单位'">
            <dict-select
              v-model="formData.materialUnit"
              url="/master/common/dict/biz"
              :body="materialUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_qty') || '数量'" prop="qty">
            <el-input-number
              v-model="formData.qty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.999"
              :step="1"
              :precision="3"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_unitPrice') || '单价'"
            prop="unitPrice"
          >
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              :min="0"
              :max="99999.999"
              :step="1"
              :precision="3"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_subPrice') || '小计'">
            <el-input v-model="v_subPrice" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <choose-category-material-dialog
      :title="$l('dialog_title_chooseMaterial') || '选择物料信息'"
      :visible.sync="chooseMaterialDialogVisible"
      type="radio"
      @confirm="chooseMaterialConfirm"
      productLine="ABSHome"
      dialog-top="10vh"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { multiplyRound, format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    pdCostsOrderGoodsPackingCode: { type: String, default: '' },
    pdCostsOrderGoodsCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      materialUnitParams: { dictType: 'moqUnit' },
      chooseMaterialDialogVisible: false,
      rules: {
        materialNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    subPrice() {
      const { qty, unitPrice } = this.formData
      return multiplyRound(qty, unitPrice)
    },
    v_subPrice() {
      return format(this.subPrice)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderGoodsPackingCode) return
      const res = await this.$api
        .pdCostsOrderGoodsPackingDetailApi({
          pdCostsOrderGoodsPackingCode: this.pdCostsOrderGoodsPackingCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.loadingOpen()
      const res = await this.$api
        .pdCostsOrderGoodsPackingSaveApi({
          ...this.formData,
          pdCostsOrderGoodsCode: this.pdCostsOrderGoodsCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    chooseMaterialConfirm(data) {
      console.log('chooseMaterialConfirm >>', data)
      if (!data) return
      const {
        materialCode,
        materialNo,
        materialName,
        detailMaterialCategoryCode,
        detailMaterialCategoryName,
      } = data
      this.formData = {
        ...this.formData,
        materialCode,
        materialNo,
        materialName,
        detailMaterialCategoryCode,
        detailMaterialCategoryName,
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
